<div container classes="container">
  <div
    class="references__accordion position-relative z-0 d-flex flex-column gap-3"
    ngbAccordion
    #accordions="ngbAccordion"
  >
    <div ngbAccordionItem="references-item" [destroyOnHide]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton id="references-toggle">
          <h3 class="mb-0 text-dark">References</h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="references-content">
              <ol>
                <li>
                  Greenbaum, C., VanBuecken, D. & Lord, S. Disease-Modifying
                  Therapies in Type 1 Diabetes: A Look into the Future of
                  Diabetes Practice. Drugs 79, 43–61 (2019).
                </li>
                <li>
                  Beyond Type 1. The Family Factor: A T1D Risk Awareness Survey.
                  Commissioned by Sanofi; July 2026.
                </li>
                <li>
                  Diabetes Leadership Council. Type 1 Diabetes Early Detection.
                  Gettingaheadoftype1.org. Published 2025.
                  <a
                    class="text-dark text-decoration-none fw-normal"
                    href="https://www.gettingaheadoftype1.org/resources/providers"
                    target="_blank"
                    rel="noopener noreferrer"
                    >https://www.gettingaheadoftype1.org/resources/providers</a>
                </li>
              </ol>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
